<template>
  <div class="ProjectInfo">
    <ComBox title="进出场实况" :element="element">
      <div class="info" :style="`top: ${changeDevicePixelRatio(50)}px;`">
        <div class="list">
          <div
            v-for="item in personList"
            :key="item.recordId"
            class="item"
            :style="`margin-bottom: ${changeDevicePixelRatio(
              10
            )}px;border-radius: ${changeDevicePixelRatio(10)}px;`"
          >
            <div class="img">
              <img :src="item.recordPhotoUrl || personAvatar" alt="" />
            </div>
            <div
              class="userInfo"
            >
              <div class="txt ellipsis">{{ item.personName }}</div>
              <div class="txt ellipsis">{{ item.teamName }}</div>
              <div class="txt ellipsis">{{ item.workerTypeName }}</div>
            </div>
            <div
              class="idenInfo"
            >
              <div class="txt ellipsis">{{ item.idcardNumber }}</div>
            </div>
            <div class="inOutInfo">
              <div class="icon" :style="`width: ${changeDevicePixelRatio(20)}px;height: ${changeDevicePixelRatio(15)}px;`">
                <img
                  v-if="item.entryExitType == '1'"
                  src="../../../../../../assets/images/custom-screen/in.png"
                  alt=""
                />
                <img
                  v-else
                  src="../../../../../../assets/images/custom-screen/out.png"
                  alt=""
                />
              </div>
              <div
                class="desc"
                :class="{
                  green: item.entryExitType == '1',
                  red: item.entryExitType == '2',
                }"
              >
                {{ item.entryExitType == "1" ? "进场" : "出场" }}
              </div>
              <div class="time ellipsis">{{ item.recordTime }}</div>
              <div class="device ellipsis">{{ item.deviceName }}</div>
            </div>
          </div>
        </div>
      </div>
    </ComBox>
  </div>
</template>

<script>
import ComBox from '../ComBox.vue'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
export default {
  components: { ComBox },
  props: {
    personList: {
      type: Array,
      default: () => {
        return []
      }
    },
    element: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      personAvatar: require('../../../../../../assets/images/new-screen/face.png')
    }
  },
  computed: {
    listFontSize() {
      const px = Math.ceil(12 / window.devicePixelRatio)
      return px
    }
  },
  created() {},

  methods: {
    changeDevicePixelRatio
  }
}
</script>

<style lang="scss" scoped>
.ProjectInfo {
  width: 414px;
  height: 590px;
  position: relative;
  .info {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    .list {
      color: #fff;
      .item {
        background: rgba(0, 82, 217, 0.498039215686275);
        margin: 0 3%;
        margin-bottom: 10px;
        border-radius: 10px;
        display: flex;
        padding: 4%;
        .img {
          width: 20%;
          padding-bottom: 20%;
          flex-shrink: 0;
          position: relative;
          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
          }
        }
        .txt {
          // margin-top: 10px;
        }
        .userInfo {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding-left: 2%;
          width: 23%;
          .txt{

          }
        }
        .idenInfo {
          padding-left: 2%;
          flex: 1;
          max-width: 23%;
          .txt{
          }
        }
        .inOutInfo {
          line-height: 1.4;
          text-align: center;
          max-width: 40%;
          .icon {
            width: 20px;
            height: 15px;
            margin: 0 auto;
            img {
              width: 100%;
            }
          }
          .desc {
            line-height: 1.5;
          }
          .red {
            color: #d61b1f;
          }
          .green {
            color: #00cc00;
          }
          .time{
          }
          .device{
          }
        }
      }
    }
  }
}
</style>
